import React from 'react';

import Confetti from 'react-confetti';

export const SubmissionConfetti = (): React.JSX.Element => (
	<Confetti recycle={false} gravity={0.1} numberOfPieces={400} />
);
